<template>
  <div class="legal-page">
    <header class="legal-header">
      <div class="header-container">
        <router-link to="/" class="logo-link">
          <img src="/landing/logo-white.svg" alt="Макетта" class="logo" />
        </router-link>
        <router-link to="/" class="back-link">← На главную</router-link>
      </div>
    </header>

    <main class="legal-content">
      <h1>Политика возврата денежных средств</h1>
      <p class="legal-date">Дата публикации: 14 января 2025 г.</p>

      <section class="legal-section">
        <h2>1. Общие положения</h2>
        <p>1.1. Настоящая Политика возврата денежных средств (далее — «Политика») устанавливает правила и условия возврата денежных средств за услуги, оказываемые ИП Немыкиной Екатериной Сергеевной (далее — «Исполнитель») через онлайн-сервис Макетта (далее — «Сервис»).</p>
        <p>1.2. Политика является неотъемлемой частью <router-link to="/terms">Публичной оферты</router-link> и применяется ко всем платежам, совершённым Пользователями за подписку на Сервис.</p>
      </section>

      <section class="legal-section">
        <h2>2. Характер предоставляемых услуг</h2>
        <p>2.1. Сервис Макетта предоставляет доступ к цифровому продукту — онлайн-платформе для создания проектов оформления мероприятий.</p>
        <p>2.2. Услуга считается оказанной в момент предоставления Пользователю доступа к функционалу оплаченного тарифного плана.</p>
        <p>2.3. Так как услуга является цифровым продуктом и доступ предоставляется мгновенно после оплаты, возврат денежных средств имеет ограничения, описанные в настоящей Политике.</p>
      </section>

      <section class="legal-section highlight-section">
        <h2>3. Условия возврата денежных средств</h2>
        
        <div class="important-notice">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#e74c3c" stroke-width="2"/>
            <line x1="12" y1="8" x2="12" y2="12" stroke="#e74c3c" stroke-width="2" stroke-linecap="round"/>
            <line x1="12" y1="16" x2="12.01" y2="16" stroke="#e74c3c" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <p><strong>Возврат денежных средств за оплаченную подписку не производится.</strong></p>
        </div>
        
        <p>3.1. Оплачивая подписку на Сервис, Пользователь подтверждает, что:</p>
        <ul>
          <li>Ознакомился с функционалом Сервиса (доступна бесплатная версия для тестирования)</li>
          <li>Понимает, что услуга является цифровым продуктом с мгновенным предоставлением доступа</li>
          <li>Согласен с тем, что возврат денежных средств после активации подписки не производится</li>
        </ul>
        
        <p>3.2. Отказ от подписки возможен в любой момент, однако денежные средства за неиспользованный период не возвращаются.</p>
        
        <p>3.3. При отказе от подписки доступ к платному функционалу сохраняется до окончания оплаченного периода.</p>
      </section>

      <section class="legal-section">
        <h2>4. Исключения</h2>
        <p>4.1. Возврат денежных средств может быть рассмотрен в исключительных случаях:</p>
        <ul>
          <li>Двойное списание средств по техническим причинам</li>
          <li>Ошибочный платёж (оплата не того тарифа при технической ошибке системы)</li>
          <li>Невозможность предоставления услуги по вине Исполнителя в течение более 7 календарных дней</li>
        </ul>
        
        <p>4.2. Для рассмотрения возврата в исключительных случаях необходимо:</p>
        <ol>
          <li>Обратиться в службу поддержки по email: maketta.pro@mail.ru</li>
          <li>Указать email аккаунта и дату платежа</li>
          <li>Описать причину обращения с приложением подтверждающих документов (при наличии)</li>
        </ol>
        
        <p>4.3. Срок рассмотрения обращения — до 10 рабочих дней.</p>
        <p>4.4. Решение о возврате принимается Исполнителем индивидуально в каждом случае.</p>
      </section>

      <section class="legal-section">
        <h2>5. Рекомендации перед оплатой</h2>
        <p>5.1. Перед оплатой подписки рекомендуем:</p>
        <ul>
          <li><strong>Протестировать бесплатную версию</strong> — зарегистрируйтесь и ознакомьтесь с базовым функционалом Сервиса</li>
          <li><strong>Изучить описание тарифов</strong> — убедитесь, что выбранный тариф соответствует вашим потребностям</li>
          <li><strong>Ознакомиться с Публичной офертой</strong> — прочитайте условия использования Сервиса</li>
          <li><strong>Связаться с поддержкой</strong> — если у вас есть вопросы, напишите нам до оплаты</li>
        </ul>
      </section>

      <section class="legal-section">
        <h2>6. Способ возврата (при одобрении)</h2>
        <p>6.1. В случае одобрения возврата денежные средства возвращаются тем же способом, которым была произведена оплата.</p>
        <p>6.2. Срок возврата денежных средств — до 10 рабочих дней с момента принятия решения о возврате.</p>
        <p>6.3. Комиссия платёжной системы при возврате не компенсируется.</p>
      </section>

      <section class="legal-section">
        <h2>7. Контактная информация</h2>
        <p>По всем вопросам, связанным с возвратом денежных средств, обращайтесь:</p>
        <div class="contact-info">
          <p><strong>Email:</strong> maketta.pro@mail.ru</p>
        </div>
      </section>

      <section class="legal-section">
        <h2>8. Заключительные положения</h2>
        <p>8.1. Настоящая Политика вступает в силу с момента её публикации на сайте.</p>
        <p>8.2. Исполнитель оставляет за собой право вносить изменения в Политику без предварительного уведомления Пользователей.</p>
        <p>8.3. Актуальная версия Политики всегда доступна на сайте maketta.pro.</p>
      </section>
    </main>

    <footer class="legal-footer">
      <p>© 2025 — {{ currentYear }} Макетта. Все права защищены.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'RefundPolicy',
  data() {
    return { currentYear: new Date().getFullYear() }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background: #f8f9fa;
}

.legal-header {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  padding: 20px 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  height: 36px;
  width: 99px;
  object-fit: contain;
}

.back-link {
  color: #fff;
  text-decoration: none;
  font-weight: 500;
  opacity: 0.9;
  transition: opacity 0.2s;
}

.back-link:hover {
  opacity: 1;
}

.legal-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  background: #fff;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

h1 {
  font-size: 32px;
  color: #1a1a2e;
  margin-bottom: 10px;
}

.legal-date {
  color: #666;
  margin-bottom: 40px;
}

.legal-section {
  margin-bottom: 30px;
}

.legal-section h2 {
  font-size: 20px;
  color: #1a1a2e;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.legal-section p {
  color: #444;
  line-height: 1.7;
  margin-bottom: 10px;
}

.legal-section ul,
.legal-section ol {
  margin: 10px 0 10px 20px;
  color: #444;
  line-height: 1.7;
}

.legal-section li {
  margin-bottom: 8px;
}

.highlight-section {
  background: #fff5f5;
  padding: 25px;
  border-radius: 12px;
  border: 1px solid #fecaca;
}

.important-notice {
  display: flex;
  align-items: center;
  gap: 15px;
  background: #fee2e2;
  padding: 15px 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.important-notice svg {
  flex-shrink: 0;
}

.important-notice p {
  margin: 0;
  color: #991b1b;
}

.contact-info {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-top: 15px;
}

.contact-info p {
  margin-bottom: 8px;
}

.contact-info p:last-child {
  margin-bottom: 0;
}

.legal-footer {
  text-align: center;
  padding: 30px;
  color: #666;
}

@media (max-width: 768px) {
  h1 {
    font-size: 24px;
  }
  
  .legal-content {
    padding: 20px 15px;
  }
  
  .highlight-section {
    padding: 15px;
  }
  
  .important-notice {
    flex-direction: column;
    text-align: center;
  }
}
</style>
